'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n      background-image: url(', ');\n\n      @media (min-width: ', ') {\n        background-image: url(', ');\n      }\n    '], ['\n      background-image: url(', ');\n\n      @media (min-width: ', ') {\n        background-image: url(', ');\n      }\n    ']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactEmotion = require('react-emotion');
var _variables = require('../utility/variables');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var loadYT = void 0;
var YoutubeVideo = function (_React$Component) {
  _inherits(YoutubeVideo, _React$Component);
  function YoutubeVideo() {
    _classCallCheck(this, YoutubeVideo);
    var _this = _possibleConstructorReturn(this, (YoutubeVideo.__proto__ || Object.getPrototypeOf(YoutubeVideo)).call(this));
    _this.state = {
      isPlaying: false
    };
    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.handlePlayerReady = _this.handlePlayerReady.bind(_this);
    _this.handlePlayerStateChange = _this.handlePlayerStateChange.bind(_this);
    _this.handlePlayClick = _this.handlePlayClick.bind(_this);
    return _this;
  }
  _createClass(YoutubeVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      if (!loadYT) {
        loadYT = new Promise(function (resolve) {
          var tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          window.onYouTubeIframeAPIReady = function () {
            return resolve(window.YT);
          };
        });
      }
      loadYT.then(function (YT) {
        _this2.player = new YT.Player(_this2.youtubePlayerAnchor, {
          videoId: _this2.props.videoId,
          height: _this2.props.height,
          width: _this2.props.width,
          playerVars: {
            playlist: _this2.props.playlist,
            autoplay: _this2.props.autoplay,
            mute: _this2.props.mute,
            loop: _this2.props.loop,
            playsinline: _this2.props.playsinline,
            controls: _this2.props.controls,
            rel: _this2.props.rel,
            showinfo: _this2.props.showinfo,
            modestbranding: _this2.props.modestbranding
          },
          events: {
            onReady: _this2.handlePlayerReady,
            onStateChange: _this2.handlePlayerStateChange
          }
        });
      });
    }
  }, {
    key: 'handleCloseClick',
    value: function handleCloseClick(e) {
      this.props.onCloseClick(e, this);
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(e) {
      this.props.onKeyPress(e, this);
    }
  }, {
    key: 'handlePlayerReady',
    value: function handlePlayerReady(e) {
      this.props.onPlayerReady(e, this);
    }
  }, {
    key: 'handlePlayerStateChange',
    value: function handlePlayerStateChange(e) {
      this.props.onPlayerStateChange(e, this);
    }
  }, {
    key: 'handlePlayClick',
    value: function handlePlayClick(e) {
      this.props.onPlayClick(e, this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var posterImage = (0, _reactEmotion.css)(_templateObject, this.props.bgMobile, _variables.mediaQueries.sm, this.props.bgDesktop);
      return _react2.default.createElement('div', {
        className: 'yt-video ' + this.props.className + ' ' + (this.state.isPlaying ? 'is-playing' : '')
      }, _react2.default.createElement('div', {
        className: 'yt-video__iframe-container ' + (this.props.posterEnabled && !this.state.isPlaying ? 'hidden' : '')
      }, _react2.default.createElement('div', {
        ref: function ref(_ref) {
          _this3.youtubePlayerAnchor = _ref;
        }
      })), this.props.posterEnabled ? _react2.default.createElement('button', {
        className: 'yt-video__close btn',
        onClick: this.handleCloseClick,
        type: 'button',
        'aria-label': 'Stop video'
      }, this.props.closeBtn) : null, this.props.posterEnabled ? _react2.default.createElement('div', {
        className: 'yt-poster ' + posterImage + ' ' + (this.props.posterClick ? 'is-clickable' : ''),
        onClick: function onClick() {
          return _this3.props.posterClick ? _this3.handlePlayClick() : false;
        },
        onKeyPress: this.handleKeyPress,
        title: this.props.bgTitle,
        role: 'button',
        tabIndex: 0,
        'arial-label': this.props.posterClick ? 'Play video' : ''
      }, _react2.default.createElement('div', {
        className: 'yt-poster__inner'
      }, _react2.default.createElement('button', {
        className: 'yt-poster__play btn ' + (!this.props.posterClick ? 'is-clickable' : ''),
        onClick: this.handlePlayClick,
        type: 'button',
        'arial-label': 'Play video'
      }, this.props.playBtn), this.props.children ? _react2.default.createElement('div', {
        className: 'yt-poster__children'
      }, this.props.children) : null)) : null);
    }
  }]);
  return YoutubeVideo;
}(_react2.default.Component);
YoutubeVideo.defaultProps = {
  bgMobile: '',
  bgDesktop: '',
  bgTitle: '',
  children: null,
  className: '',
  closeBtn: null,
  playlist: '',
  height: 390,
  width: 640,
  autoplay: 0,
  mute: 0,
  loop: 0,
  playsinline: 1,
  controls: 1,
  rel: 0,
  showinfo: 0,
  modestbranding: 0,
  onCloseClick: function onCloseClick(e, $this) {
    $this.setState({
      isPlaying: false
    });
    $this.player.stopVideo();
  },
  onKeyPress: function onKeyPress(e, $this) {
    return false;
  },
  // eslint-disable-line
  onPlayerReady: function onPlayerReady(e, $this) {
    if ($this.props.autoplay) e.target.playVideo();
  },
  onPlayerStateChange: function onPlayerStateChange(e, $this) {
    switch (e.data) {
      case YT.PlayerState.PLAYING:
        // eslint-disable-line
        if (!$this.state.isPlaying) $this.setState({
          isPlaying: true
        });
        break;
      case YT.PlayerState.ENDED:
        // eslint-disable-line
        if ($this.state.isPlaying) $this.setState({
          isPlaying: false
        });
        break;
      default:
    }
  },
  onPlayClick: function onPlayClick(e, $this) {
    $this.setState({
      isPlaying: true
    });
    $this.player.playVideo();
  },
  playBtn: null,
  posterEnabled: false,
  posterClick: false
};
YoutubeVideo.propTypes = {
  bgMobile: _propTypes2.default.string,
  bgDesktop: _propTypes2.default.string,
  bgTitle: _propTypes2.default.string,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  closeBtn: _propTypes2.default.node,
  videoId: _propTypes2.default.string.isRequired,
  playlist: _propTypes2.default.string,
  height: _propTypes2.default.number,
  width: _propTypes2.default.number,
  autoplay: _propTypes2.default.number,
  mute: _propTypes2.default.number,
  loop: _propTypes2.default.number,
  playsinline: _propTypes2.default.number,
  controls: _propTypes2.default.number,
  rel: _propTypes2.default.number,
  showinfo: _propTypes2.default.number,
  modestbranding: _propTypes2.default.number,
  onCloseClick: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  onPlayerReady: _propTypes2.default.func,
  onPlayerStateChange: _propTypes2.default.func,
  onPlayClick: _propTypes2.default.func,
  playBtn: _propTypes2.default.node,
  posterEnabled: _propTypes2.default.bool,
  posterClick: _propTypes2.default.bool
};
exports.default = YoutubeVideo;